export const fromLongToShort = {
  en_US: 'en',
  hu_HU: 'hu'
};

export const fromShortToLong = {
  en: 'en_US',
  hu: 'hu_HU'
};

export const availableLanguages = [
  'en_US',
  'hu_HU'
];



// WEBPACK FOOTER //
// ./src/lang/languageCodes.js